
import ThemeSearch from '@/components/Theme/ThemeSearch.vue'
import ThemeList from '@/components/Theme/ThemeList.vue'
import ThemeStockSearch from '@/components/Theme/ThemeStockSearch.vue'

export default {
    components: {
        ThemeSearch,
        ThemeList,
        ThemeStockSearch,
    },
    data() {
      return {
        isThemeSearch: true, // 선택값 테마:true,종목:false
      }
    },
    methods: {
      changeSearch(bool){
        if(bool){
          this.isThemeSearch = true
        } else {
          this.isThemeSearch = false
        }
      },
      onClickThemeAsk() {
      this.$router.push('/Mypage/ThemeAsk')
    },
    },
}
